import React from 'react';
import Toast, { type ToastProps } from './Toast';
import './ToastContainer.css';

export interface ToastData {
  id: string;
  type: ToastProps['type'];
  title: string;
  message: string;
  duration?: number;
  icon?: string;
}

interface ToastContainerProps {
  toasts: ToastData[];
  onRemoveToast: (id: string) => void;
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
}

const ToastContainer: React.FC<ToastContainerProps> = ({
  toasts,
  onRemoveToast,
  position = 'top-left' // Changed from 'top-right' for compact mobile-first design
}) => {
  if (toasts.length === 0) return null;

  return (
    <div className={`toast-container toast-container-${position}`}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          type={toast.type}
          title={toast.title}
          message={toast.message}
          duration={toast.duration}
          icon={toast.icon}
          onClose={onRemoveToast}
        />
      ))}
    </div>
  );
};

export default ToastContainer;